var _ellipse, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_414_1305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 52
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.9033,
    cy: 26,
    rx: 25.9033,
    ry: 26,
    fill: "#1D80C2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_414_1305)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.1063,
    cy: 26,
    rx: 30.6854,
    ry: 30.8,
    fill: "#0071BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 47.8026C12.9399 48.3635 16.3233 10.6719 46.7744 27.6083C32 -5.0001 7.5 11 -7 27.6082C13 12.5 26.5 7.5 40 21.5C13.5 12 7.86467 51.1683 62 47.8026Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.c3e786c608ac5ec17ce9fe11022c9ba5.svg";
export { ForwardRef as ReactComponent };